import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '@lib/env';
import { Observable } from 'rxjs';
import { UriBuilder } from 'uribuilder';

@Injectable({
    providedIn: 'root',
})
export class DemandPaymentTermDataService {
    private readonly http = inject(HttpClient);
    private readonly env = inject(EnvService);


    public deletePaymentTerm(demandId: string, supplierCompanyId: string): Observable<void> {
        const url = this.env.getBase('demand', demandId, 'supplier', supplierCompanyId, 'payment-term');

        return this.http.delete<void>(url.toString());
    }

    public updatePaymentTerm(demandId: string, supplierCompanyId: string, paymentTermId: number): Observable<void> {
        const uri: UriBuilder = this.env.getBase('demand', demandId, 'supplier', supplierCompanyId, 'payment-term');

        return this.http.post<void>(uri.toString(), { paymentTermId });
    }
}
